// extracted by mini-css-extract-plugin
module.exports = {"collectionContainer":"page_collectionContainer__tIaZn"};